import type { MediaSourceData, TranscriptData } from '@lumen5/luminary';
import { VideoData } from '@lumen5/luminary';

import chineseTranscript1 from './chineseTranscript1.json';
import englishTranscript1 from './englishTranscript1.json';
import englishTranscript2 from './englishTranscript2.json';
import englishTranscript3 from './englishTranscript3.json';

import { SourceEnum } from 'js/src/client';

export const sampleText1 =
    'Lorem ipsum dolor sit amet, dicat denique molestie vix te. His natum deleniti no. Eum ei affert malorum pertinax, labores signiferumque ea vim, decore tempor atomorum qui ut. Affert meliore id mei. Habeo erant conclusionemque an mel, ea nec lorem splendide. Ut qui exerci percipitur, essent appetere eu sea, ex sint aliquip constituto sed.';
export const sampleImageData1 = {
    uuid: '00000000-0000-0000-0000-000000000001',
    type: 'image',
    source: SourceEnum.SOURCE_UNSPLASH,
    source_id: 'asdf1',
    license: VideoData.USER_PRIVATE_LICENSE,
    is_editorial: false,
    preview_url:
        'https://storage.googleapis.com/lumen5-prod-images/photo-1489898396181-b6e9a25f6980c2bIHA.jpg',
    thumbnail_url:
        'https://storage.googleapis.com/lumen5-prod-images/photo-1489898396181-b6e9a25f6980c2bIHA.jpg',
    render_url:
        'https://storage.googleapis.com/lumen5-prod-images/photo-1489898396181-b6e9a25f6980c2bIHA.jpg',
    width: 5184,
    height: 3456,
} as MediaSourceData;

export const sampleImageData2 = {
    uuid: '00000000-0000-0000-0000-000000000002',
    type: 'image',
    source: SourceEnum.SOURCE_GETTY,
    source_id: 'asdf2',
    license: VideoData.USER_PRIVATE_LICENSE,
    is_editorial: false,
    thumbnail_url:
        'https://storage.googleapis.com/lumen5-user-d23bf699-997a-4754-8b71-30360f7a0f4c/7kHaRMm.jpg',
    preview_url:
        'https://storage.googleapis.com/lumen5-user-d23bf699-997a-4754-8b71-30360f7a0f4c/7kHaRMm.jpg',
    render_url:
        'https://storage.googleapis.com/lumen5-user-d23bf699-997a-4754-8b71-30360f7a0f4c/7kHaRMm.jpg',
    width: 1024,
    height: 576,
} as MediaSourceData;

export const sampleImageDataInvisible = {
    uuid: '00000000-0000-0000-0000-000000000007',
    type: 'image',
    source: SourceEnum.SOURCE_LUMEN5_ASSETS,
    source_id: 'asdf3',
    license: VideoData.USER_PRIVATE_LICENSE,
    is_editorial: false,
    preview_url: VideoData.INVISIBLE_IMAGE,
    render_url: VideoData.INVISIBLE_IMAGE,
    thumbnail_url: VideoData.INVISIBLE_IMAGE,
    width: 640,
    height: 480,
} as MediaSourceData;

export const NO_TRANSCRIPT_LABEL = 'None';

export const sampleTranscripts = [
    {
        label: NO_TRANSCRIPT_LABEL,
        transcriptData: {
            words: [],
            language: 'en',
            textDirection: 'ltr',
            separateWordsWithSpaces: true,
        },
    },
    {
        label: 'english 1',
        transcriptData: englishTranscript1,
    },
    {
        label: 'english 2',
        transcriptData: englishTranscript2,
    },
    {
        label: 'english 3',
        transcriptData: englishTranscript3,
    },
    {
        label: 'chinese 1',
        transcriptData: chineseTranscript1,
    },
] as { label: string; transcriptData: TranscriptData }[];

export const sampleTranscriptLabels = sampleTranscripts.map((transcript) => transcript.label);
